'use client'

import { IconSearch, IconXCircleFill } from '@/shared/assets/icons'

const AddressSearchField = ({
  inputRef,
  currentValue,
  handleChangeInput,
  handleClearInput,
  handleClickInput,
}: {
  inputRef: React.RefObject<HTMLInputElement | null>
  currentValue: string
  handleChangeInput: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleClearInput: () => void
  handleClickInput: () => void
}) => {
  return (
    <div className='w-full flex items-center justify-between gap-x2 py-dimension-x2 pl-dimension-x3 pr-dimension-x1 bg-background-neutral-weak rounded-xl overflow-hidden'>
      <div className='flex-1 flex items-center gap-dimension-x2 justify-between min-w-0 h-dimension-x8'>
        <IconSearch fill='#6D7882' width='20' height='20' />
        <input
          ref={inputRef}
          type='text'
          value={currentValue}
          placeholder='건물명, 도로명, 지번으로 검색'
          className='flex-1 text-title-2-medium text-foreground-neutral-strong caret-foreground-brand-strong truncate min-w-0'
          onChange={handleChangeInput}
          autoFocus
          onClick={handleClickInput}
        />
      </div>

      {currentValue && (
        <button
          className='w-dimension-x8 h-dimension-x8 flex items-center justify-center p-dimension-x2 min-w-0'
          onClick={handleClearInput}
        >
          <IconXCircleFill fill='#8E98A0' width='16' height='16' />
        </button>
      )}
    </div>
  )
}

export default AddressSearchField
